import { IImagesModel } from "../interfaces/model";
import { fileToBase64 } from "../utils";
import { apiBaseUrl, defaultSaveConfig } from "./config.api.baseUrl";
import { loadImage, removeImage } from "../store";

export const baseMediaObjectIri = '/api/media_objects';

export const imageConfigApiFormat = [
    { path: "base64", type: "transformBase64" },
];

// Create Post Request for saving Image
export const apiSaveImage = async (userToken: string, image: IImagesModel) => {
    if (!image.fileId) {
        throw new Error('No fileId provided.');
    }

    const file: Blob | File | null = await loadImage(image.fileId);
    if (file) {
        image.base64 = (await fileToBase64(file)) ?? undefined;
    }

    const response = await apiBaseUrl(userToken)(
        defaultSaveConfig(image, baseMediaObjectIri, imageConfigApiFormat)
    );

    if (response.status === 201 || response.status === 200) {
        await removeImage(image.fileId);
        image.fileId = undefined;
    }

    image.base64 = undefined;
    return response;
};
